module.exports = __webpack_public_path__ + "media/site_templates/www.bathroomrenovations.biz/images/our_services_1-474498c81e2f2c22b1d6c415f30f350f.jpg";